<template>
  <v-container fluid class="user-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs color="primary">
          <v-tabs-slider></v-tabs-slider>
          <v-tab :href="`#tab-impacto`" class="mr-5"> Impacto </v-tab>
          <v-tab class="mr-5" :href="`#tab-realizacao`"> Realização </v-tab>
          <v-tab class="mr-5" :href="`#tab-produto`"> Produtos </v-tab>
          <v-tab class="mr-5" :href="`#tab-atividades`"> Atividades </v-tab>

          <v-tab-item :value="'tab-impacto'">
            <v-row>
              <v-col cols="12">
                <v-card elevation="0" tile class="mx-1">
                  <v-card-title >
                    <p>Impacto</p>
                  </v-card-title>
                  <v-divider></v-divider>
                </v-card>
                
                <template v-for="(item, index) in impactos">
                  <LogicaIntervencaoListItem
                    :key="'impacto-' + index"
                    :logicaIntervencao="item"
                  ></LogicaIntervencaoListItem>
                </template>
              </v-col>
            </v-row>
            <v-row class="mb-12 mt-n6" v-if="impactos.length < 1">
              <v-col cols="12" class="mb-n6">
                <v-card tile class="mx-1">
                  <v-card-text style="height: 50px; position: relative">
                    <v-fab-transition>
                      <LogicaIntervencaoCriacao
                        titulo="Criar Impacto"
                        nivel="OBJETIVO_GERAL"
                      ></LogicaIntervencaoCriacao>
                    </v-fab-transition>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item :value="'tab-realizacao'">
            <v-row>
              <v-col cols="12">
                <v-card elevation="0" tile class="mx-1">
                  <v-card-title >
                    <p>Realização</p>
                  </v-card-title>
                  <v-divider></v-divider>
                </v-card>

                <template v-if="realizacoes.length">
                  <template v-for="(item, index) in realizacoes">
                    <LogicaIntervencaoListItem
                      :key="'REALIZACAO-' + index"
                      :logicaIntervencao="item"
                    ></LogicaIntervencaoListItem>
                  </template>
                </template>
              </v-col>
            </v-row>
            <v-row class="mb-12 mt-n6" v-if="realizacoes.length < 1">
              <v-col cols="12" class="mb-n6">
                <v-card tile class="mx-1">
                  <v-card-text style="height: 50px; position: relative">
                    <v-fab-transition>
                      <LogicaIntervencaoCriacao
                        titulo="Criar Realização"
                        nivel="OBJETIVO_ESPECIFICO"
                      ></LogicaIntervencaoCriacao>
                    </v-fab-transition>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item :value="'tab-produto'">
            <template v-for="(realizacao, index) in realizacoes">
              <div :key="'ip' + index">
                <v-card elevation="0" tile class="mx-1">
                  <v-card-title >
                    <p>Produtos</p><span class="grey--text font-weight-regular subtitle-2 pt-1">{{'\xa0 (' +  realizacao.produtos.length }} total) </span>
                  </v-card-title>
                  <v-divider></v-divider>
                </v-card>

                <v-card elevation="0" tile class="mx-1">
                  <v-list>
                    <v-list-item link>
                      <v-list-item-content>
                        <v-list-item-subtitle>{{ realizacao.posicaoFormatada }} Realização</v-list-item-subtitle>
                        <v-list-item-title>
                          {{ realizacao.descricao }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <v-divider></v-divider>
                </v-card>

                <template v-for="(produto, index) in realizacao.produtos">
                  <LogicaIntervencaoListItem
                    :key="'produto-' + index"
                    :logicaIntervencao="produto"
                  ></LogicaIntervencaoListItem>
                  
                </template>
                <v-card tile class="mx-1">
                  <v-card-text
                    class="mb-12"
                    style="height: 50px; position: relative"
                  >
                    <v-fab-transition>
                      <LogicaIntervencaoCriacao
                        titulo="Criar Produto"
                        nivel="RESULTADO_ESPERADO"
                        :realizacao="realizacao"
                      ></LogicaIntervencaoCriacao>
                    </v-fab-transition>
                  </v-card-text>
                </v-card>
              </div>
            </template>
          </v-tab-item>

          <v-tab-item :value="'tab-atividades'">
            <template v-for="(realizacao) in realizacoes">
              <template v-for="(produto, index) in realizacao.produtos">
                <div :key="'ipa' + index" class="mb-12">
                  <v-card tile class="mx-1">
                    <v-card-title >
                      <p>Atividades</p><span class="grey--text font-weight-regular subtitle-2 pt-1">{{'\xa0 (' +  produto.atividades.length }} total) </span>
                    </v-card-title>
                    <v-divider></v-divider>
                  </v-card>

                  <v-card elevation="1" tile class="mx-1">
                    <v-list>
                      <v-list-item link>
                        <v-list-item-content>
                          <v-list-item-subtitle>{{ realizacao.posicaoFormatada }} Realização</v-list-item-subtitle>
                          <v-list-item-title class="text-wrap">
                            {{ realizacao.descricao }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item link>
                        <v-list-item-content>
                          <v-list-item-subtitle>{{ produto.posicaoFormatada }} Produto</v-list-item-subtitle>
                          <v-list-item-title class="text-wrap">
                            {{ produto.descricao }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                    <v-divider></v-divider>
                  </v-card>

                  <template v-for="(atividade, index) in produto.atividades">
                    <LogicaIntervencaoListItem
                      :key="'atividade-' + index"
                      :logicaIntervencao="atividade"
                    ></LogicaIntervencaoListItem>
                  </template>

                  <v-card tile class="mx-1">
                    <v-card-text
                      class="mb-12"
                      style="height: 50px; position: relative"
                    >
                      <v-fab-transition>
                        <LogicaIntervencaoCriacao
                          titulo="Criar Atividade"
                          nivel="ATIVIDADE"
                          :realizacao="realizacao"
                          :produto="produto"
                        ></LogicaIntervencaoCriacao>
                      </v-fab-transition>
                    </v-card-text>
                  </v-card>
                </div>
              </template>
            </template>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LogicaIntervencaoListItem from "@/pages/Projeto/components/LogicaIntervencao/LogicaIntervencaoListItem";
import LogicaIntervencaoCriacao from "@/pages/Projeto/components/LogicaIntervencao/LogicaIntervencaoAdd";


export default {
  components: { LogicaIntervencaoListItem, LogicaIntervencaoCriacao },
  computed: {
    impactos() {
      return this.$store.getters["logicaIntervencao/impactosByProjeto"](
        parseInt(this.$route.params.projetoId)
      );
    },
    realizacoes() {
      var realizacoes = this.$store.getters[
        "logicaIntervencao/realizacoesByProjeto"
      ](parseInt(this.$route.params.projetoId));
      return realizacoes;
    },
  },
  data() {
    return {};
  },
  methods: {

  },
};
</script>

<style src="./Matriz.scss" lang="scss"></style>
